import React, { useEffect, useState, useContext } from 'react';
import PositionCard from '../components/PositionCard';
import BottomSheetPortfolio from '../components/BottomSheetPortfolio';
import { WebSocketContext } from "../WebSocketContext";
import { useTheme } from '../contexts/ThemeContext';
import config from '../config'; // Assuming you have a config file with API_BASE_URL
import '../Performance.css'; // Assuming you will style the portfolio page
import PerformanceCard from '../components/PerformanceCard';
import { Refresh } from '@mui/icons-material';

const Performance = () => {

  const { performance , userDetails, refreshTradesAndPortfolio, refreshPerformance } = useContext(WebSocketContext);
  const { isDarkMode } = useTheme();
  const [isDetailsExpanded, setIsDetailsExpanded] = useState(false);
  let grossPnl = 0;

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  //console.log("Profile userDetails",userDetails);

  const toggleDepth = () => {
      setIsDetailsExpanded(!isDetailsExpanded);
    };

  //console.log("Performance rendered");
  
  const list = performance != null && Array.isArray(performance) ? performance : [];

  // Calculate total PnL (safe when performance is null/undefined or not array)
  const calculateTotalPnL = () => {
    const total = list.reduce((sum, position) => {
      const pnl = Number(position?.pnl) || 0;
      return sum + pnl;
    }, 0);
    grossPnl = total;
    return Number(total).toFixed(2);
  };

  // Total brokerage: close + open (dono side). Prefer closing_order when nested.
  // Use != null checks so a valid 0 is kept; round to 2dp to match LOT flat amounts.
  const totalBrokerage = list.reduce((sum, position) => {
    const close = position?.closing_order || position;
    const closeBr = Number(close?.brokerage) || 0;
    let openBr = 0;
    if (close?.openBrokerage != null && close.openBrokerage !== '') {
      openBr = Number(close.openBrokerage) || 0;
    } else if (position?.openBrokerage != null && position.openBrokerage !== '') {
      openBr = Number(position.openBrokerage) || 0;
    } else if (position?.opening_order?.brokerage != null) {
      openBr = Number(position.opening_order.brokerage) || 0;
    }
    return sum + closeBr + openBr;
  }, 0);
  const totalBrokerageDisplay = Math.round(totalBrokerage * 100) / 100;

  const handleRefresh = () => {
    refreshTradesAndPortfolio("both");
  };

  return (
    <div className={`portfolio-page ${isDarkMode ? 'dark-theme' : 'light-theme'}`} data-theme={isDarkMode ? 'dark' : 'light'}>
      <button className="refresh-button" onClick={handleRefresh}><Refresh /></button>
      <span style={{display:'none'}}>{calculateTotalPnL()}</span>

      <div className="pnl-cards-container" onClick={toggleDepth}>
        <div className="pnl-card gross-pnl">
          <div className="pnl-card-header">
            <span className="pnl-card-title">Gross P&L</span>
          </div>
          <div className="pnl-card-value">
            <span className={`pnl-amount ${grossPnl < 0 ? 'negative' : 'positive'}`}>
              ₹{Number(grossPnl).toFixed(2)}
            </span>
          </div>
        </div>
        
        <div className="pnl-card brokerage-pnl">
          <div className="pnl-card-header">
            <span className="pnl-card-title">Brokerage</span>
          </div>
          <div className="pnl-card-value">
            <span className="pnl-amount negative">
              ₹-{(Number(totalBrokerageDisplay) || 0).toFixed(2)}
            </span>
          </div>
        </div>
        
        <div className="pnl-card net-pnl">
          <div className="pnl-card-header">
            <span className="pnl-card-title">Net P&L</span>
          </div>
          <div className="pnl-card-value">
            <span className={`pnl-amount ${(Number(calculateTotalPnL()) - (Number(totalBrokerageDisplay) || 0)) < 0 ? 'negative' : 'positive'}`}>
              ₹{(Number(calculateTotalPnL()) - (Number(totalBrokerageDisplay) || 0)).toFixed(2)}
            </span>
          </div>
        </div>
      </div>

      
      {performance && Array.isArray(performance) && performance.length > 0 ? (
        performance.map(position => (
          <PerformanceCard 
            key={position.orderId ?? position.closing_order?.orderId ?? position.exeDateTime ?? Math.random()}
            performance={position}
            isDarkMode={isDarkMode}
          />
        ))
      ) : (
        <div className="net-pos-empty-state">
          <h3>No Deals</h3>
          <p>
            {performance == null
              ? 'Fetching deals...'
              : "You don't have any deals at the moment."}
          </p>
        </div>
      )}
    </div>
  );
}

export default Performance;

